import React, { useState } from "react";
import { sendCSV } from "../src/utils/requests";
import "./scss/app.scss";
import dontayImg from "./images/favicon.png";
const App = () => {
  const [csv, setCsv] = useState(null);
  // const [climit, setClimit] = useState(20);
  const [climit, setClimit] = useState(() => {
    const val = localStorage.getItem("climit");
    return val !== null ? Number(val) : 20;
  });
  // const [fileLink, setFileLink] = useState("");
  const handleCsvUpload = async (e) => {
    //get file from input
    const uploadedFile = e.target.files[0];
    setCsv(uploadedFile);
  };
  const handleClimit = async (e) => {
    //get file from input
    const uploadedFile = Number(e.target.value);
    setClimit(uploadedFile);
  };

  const handleServerSend = async (e) => {
    const btn = document.getElementById("submit");
    btn.textContent = "Reformatting...";

    const Data = new FormData();
    Data.append("file", csv);
    Data.append("char_limit", climit);

    const result = await sendCSV(Data);

    if (result === 0) {
      alert(
        "There was some sort of error. Contact Tech, they may be able to help"
      );
      return;
    }

    localStorage.setItem("climit", climit);

    // Download using blob
    const url = window.URL.createObjectURL(result.blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = result.filename || "result.itt"; // fallback filename
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setTimeout(() => {
      btn.textContent = "Submit";
      formReset();
    }, 1000);

    // Optionally, update state as you wish...
    // setFileLink(result)
    return;
  };

  const formReset = (e) => {
    setCsv(null);
    // setFileLink("");
    const input = document.getElementById("fileInput");
    input.value = null;
  };

  return (
    <div className="App--wrapper">
      <div className="App--troll bl">
        <img src={dontayImg} alt="dontayyy" />
      </div>
      <div className="App--troll tl">
        <img src={dontayImg} alt="dontayyy" />
      </div>
      <div className="App--troll tr">
        <img src={dontayImg} alt="dontayyy" />
      </div>
      <div className="App--troll br">
        <img src={dontayImg} alt="dontayyy" />
      </div>
      <div className="App">
        <div className="App--inner"></div>
        <div className="App--content">
          <h1>Spl.itt Captions</h1>
          <input
            id="fileInput"
            type="file"
            onChange={handleCsvUpload}
            accept=".itt,.srt"
          />
          <label>
            Character Limit
            <input
              type="number"
              step={1}
              value={climit}
              onChange={handleClimit}
            ></input>
          </label>

          <button
            id="submit"
            className={`CTA ${csv === null ? "disabled" : ""}`}
            onClick={handleServerSend}
          >
            Submit
          </button>

          {/* <button className="CTA green inverse" onClick={formReset}>
            Reset Form
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default App;
